<template>
    <!--  个人中心 -->
    <div class="personalCenter">
        <el-tabs v-model="activeColumn" type="border-card" class="tabs-card-one">
            <el-tab-pane name="one" label="基金自选">
                <div class="text-r">
                    <el-button type="built" @click="gotoContrast"><i class="el-icon-pie-chart"></i> 去对比</el-button>
                </div>
                <el-table class="table-two mt20" :data="fundTable" :default-sort="{prop:'newestDate', order: 'descending'}" border @sort-change="tableSortChange" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="基金简称" fixed width="200">
                        <template slot-scope="scope">
                            <a class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/product?code='+scope.row.innerCode" target="_blank">{{scope.row.secuNameAbbr}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="基金公司名称" fixed width="200">
                        <template slot-scope="scope">
                            <a class="line_one mainColor" :title="scope.row.firmName" :href="'#/company?code='+scope.row.firmCode" target="_blank">{{scope.row.firmName}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="一级投资策略" prop="primaryType" width="110"></el-table-column>
                    <el-table-column label="最新净值日期" prop="newestDate" width="130" sortable="custom" :sort-orders="['ascending', 'descending']"></el-table-column>
                    <el-table-column label="最新净值" prop="newestEquity" width="110" sortable="custom" :sort-orders="['ascending', 'descending']"></el-table-column>
                    <el-table-column label="年化收益" prop="annualYield" width="110" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.annualYield == '--'">--</span>
                            <span v-else :class="scope.row.annualYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.annualYield}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="近一月收益" prop="oneMonthYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.oneMonthYield == '--'">--</span>
                            <span v-else :class="scope.row.oneMonthYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.oneMonthYield}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="近三月收益" prop="threeMonthYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.threeMonthYield == '--'">--</span>
                            <span v-else :class="scope.row.threeMonthYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.threeMonthYield}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="近六月收益" prop="sixMonthYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.sixMonthYield == '--'">--</span>
                            <span v-else :class="scope.row.sixMonthYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.sixMonthYield}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="近一年收益" prop="oneYearYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.oneYearYield == '--'">--</span>
                            <span v-else :class="scope.row.oneYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.oneYearYield}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="近三年收益" prop="threeYearYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.threeYearYield == '--'">--</span>
                            <span v-else :class="scope.row.threeYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.threeYearYield}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="近五年收益" prop="fiveYearYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.fiveYearYield == '--'">--</span>
                            <span v-else :class="scope.row.fiveYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.fiveYearYield}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="今年以来收益" prop="thisYearYield" width="130" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.thisYearYield == '--'">--</span>
                            <span v-else :class="scope.row.thisYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.thisYearYield}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="成立以来收益" prop="totalYield" width="130" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.totalYield == '--'">--</span>
                            <span v-else :class="scope.row.totalYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.totalYield}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="new Date().getFullYear()-1 +'年收益'" prop="lastYearYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastYearYield == '--'">--</span>
                            <span v-else :class="scope.row.lastYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.lastYearYield}}</span>
                        </template></el-table-column>
                    <el-table-column :label="new Date().getFullYear()-2 +'年收益'" prop="lastTwoYearYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastTwoYearYield == '--'">--</span>
                            <span v-else :class="scope.row.lastTwoYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.lastTwoYearYield}}</span>
                        </template></el-table-column>
                    <el-table-column :label="new Date().getFullYear()-3 +'年收益'" prop="lastThreeYearYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastThreeYearYield == '--'">--</span>
                            <span v-else :class="scope.row.lastThreeYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.lastThreeYearYield}}</span>
                        </template></el-table-column>
                    <el-table-column :label="new Date().getFullYear()-4 +'年收益'" prop="lastFourYearYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastFourYearYield == '--'">--</span>
                            <span v-else :class="scope.row.lastFourYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.lastFourYearYield}}</span>
                        </template></el-table-column>
                    <el-table-column :label="new Date().getFullYear()-5 +'年收益'" prop="lastFiveYearYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastFiveYearYield == '--'">--</span>
                            <span v-else :class="scope.row.lastFiveYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.lastFiveYearYield}}</span>
                        </template></el-table-column>
                    <el-table-column :label="new Date().getFullYear()-6 +'年收益'" prop="lastSixYearYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastSixYearYield == '--'">--</span>
                            <span v-else :class="scope.row.lastSixYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.lastSixYearYield}}</span>
                        </template></el-table-column>
                    <el-table-column :label="new Date().getFullYear()-7 +'年收益'" prop="lastSevenYearYield" width="120" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastSevenYearYield == '--'">--</span>
                            <span v-else :class="scope.row.lastSevenYearYield.replace('%','')>=0? 'rColor':'gColor'">{{scope.row.lastSevenYearYield}}</span>
                        </template></el-table-column>
                    <el-table-column label="创建日期" prop="createDate" width="100"></el-table-column>
                    <el-table-column label="交易日期" prop="dealDate" width="100"></el-table-column>
                    <el-table-column label="备案日期" prop="regionDate" width="100"></el-table-column>
                </el-table>
                <el-pagination class="pagination-one mt20" hide-on-single-page background :page-size="fund.pageNum" :current-page="fund.page" layout="prev, pager, next" @current-change="fundCurrentChange" :total="fund.pageAll"></el-pagination>
            </el-tab-pane>
            <el-tab-pane name="two" label="管理人自选">
                <el-table class="table-two" :data="custodianTable" ref="custodianTableRef" border>
                    <el-table-column label="基金简称" prop="secuNameAbbr" width="200">
                        <template slot-scope="scope">
                            <a class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/company?code='+scope.row.innerCode" target="_blank">{{scope.row.secuNameAbbr}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="备案号" prop="recordCode"></el-table-column>
                    <el-table-column label="核心人物" prop="keyPerson"></el-table-column>
                    <el-table-column label="成立日期" prop="createDate"></el-table-column>
                    <el-table-column label="管理规模" prop="assetRange"></el-table-column>
                    <el-table-column label="注册资本" prop="regCapital"></el-table-column>
                    <el-table-column label="实缴资本" prop="actulCapital"></el-table-column>
                    <el-table-column label="员工人数" prop="employeeNum"></el-table-column>
                </el-table>
                <el-pagination class="pagination-one mt20" hide-on-single-page background :page-size="custodian.pageNum" :current-page="custodian.page" layout="prev, pager, next" @current-change="custodianCurrentChange" :total="custodian.pageAll"></el-pagination>
            </el-tab-pane>
            <el-tab-pane name="three" label="我的投顾池">
                <myInvestmentAdvisoryPool></myInvestmentAdvisoryPool>
            </el-tab-pane>
            <el-tab-pane name="four" label="我的模拟组合">
                <analogCombinationDetails></analogCombinationDetails>
            </el-tab-pane>
            <el-tab-pane name="five" label="内部产品">
                <div class="text-r">
                    <el-button type="built" @click="operateInner('add')"><i class="el-icon-plus"></i> 新建产品</el-button>
                    <el-button type="built">
                        <a href="https://kingfund.myfund.com/files/内部产品净值导入模板.xlsx" target="_blank" download="净值导入模板"><i class="el-icon-bottom"></i> 净值导入模板</a>
                    </el-button>
                </div>
                <el-table class="table-two mt20" :data="productTable" border>
                    <el-table-column label="基金简称" prop="secuName" width="200">
                        <template slot-scope="scope">
                            <a class="line_one mainColor" :title="scope.row.secuName" :href="'#/product?type=inner'+'&code='+scope.row.innerCode" target="_blank">{{scope.row.secuName}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="成立日期" prop="createDate"></el-table-column>
                    <el-table-column label="基金管理人" prop="fundAdviser"></el-table-column>
                    <el-table-column label="基金托管人" prop="fundManager"></el-table-column>
                    <el-table-column label="一级策略" prop="primaryType"></el-table-column>
                    <el-table-column label="操作" width="300">
                        <template slot-scope="scope">
                            <el-upload style="display:inline-block;" action :show-file-list="false" :on-progress="(event, file, fileList) => {importChange(event, file, fileList, scope.row)}">
                                <span class="btn-normal">估值表导入</span>
                            </el-upload>
                            <span class="btn-normal" @click="operateInner('edit',scope.row)">编辑</span>
                            <span class="btn-normal" @click="delInner(scope.row)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 新建/编辑产品 -->
                <el-dialog :title="operateType=='add'?'新建产品':'编辑产品'" class="dialog-normal clearfix" :visible.sync="dialogVisible" @close="innerClose">
                    <el-form class="form-one mt30" :rules="addFormRules" ref="addFormRef" :model="addForm" :inline="true" label-position="right" label-width="135px">
                        <el-form-item label="产品名称" prop="name">
                            <el-input v-model="addForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="备案编号" prop="regNum">
                            <el-input v-model="addForm.regNum"></el-input>
                        </el-form-item>
                        <el-form-item label="成立日期" prop="createDate">
                            <el-date-picker type="date" class="date-picker-one" style="width: 100%;margin-right: 10px;" v-model="addForm.createDate" :editable="false" :clearable="false" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="基金管理人" prop="fundAdviser">
                            <el-input v-model="addForm.fundAdviser"></el-input>
                        </el-form-item>
                        <el-form-item label="基金托管人" prop="fundManager">
                            <el-input v-model="addForm.fundManager"></el-input>
                        </el-form-item>
                        <el-form-item label="基金经理" prop="fundMember">
                            <el-input v-model="addForm.fundMember"></el-input>
                        </el-form-item>
                        <el-form-item label="投资策略" prop="primaryType">
                            <el-select v-model="addForm.primaryType" class="select-one">
                                <el-option v-for="(item,ind) in tacticsList" :key="ind" :label="item.label" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="clearfix mt10"><el-button class="fr" type="normal" @click="saveInner">保存</el-button></div>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane name="six" label="自定义指数">
                <customIndex></customIndex>
            </el-tab-pane>
            <el-tab-pane name="seven" label="我的资产">
                <myAssets></myAssets>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import myInvestmentAdvisoryPool from "./myInvestmentAdvisoryPool.vue"
    import analogCombinationDetails from "../analogCombination/analogCombinationDetails.vue"
    import customIndex from "./customIndex.vue"
    import myAssets from "./myAssets.vue"
    export default {
        name: "personalCenter",
        components: {
            myInvestmentAdvisoryPool,
            analogCombinationDetails,
            customIndex,
            myAssets,
        },
        data() {
            return {
                activeColumn: 'one',
                fundTable: [],
                fund: {
                    page: 1,
                    pageNum: 10,
                    pageAll: 0,
                    orderBy: -1,//排序字段，
                    orderFlag: 0,//0为倒序，1为正序
                },
                custodianTable: [],
                custodian: {
                    page: 1,
                    pageNum: 10,
                    pageAll: 0,
                },
                innerCodes: [],
                productTable: [],//内部产品
                product: {
                    page: 1,
                    pageNum: 10,
                    pageAll: 0,
                },
                dialogVisible: false,
                addForm: {
                    name: '',
                    regNum: '',
                    createDate: '',
                    fundAdviser: '',
                    fundManager: '',
                    fundMember: '',
                    primaryType: '',
                }, 
                addFormRules: {
                    name: [
                        { required: true, message: '请输入产品名称', trigger: 'blur' }
                    ],
                    regNum: [
                        { required: true, message: '请输入备案编号', trigger: 'blur' }
                    ],
                    createDate: [
                        { required: true, message: '请选择成立日期', trigger: 'blur' }
                    ],
                    fundAdviser: [
                        { required: true, message: '请输入基金管理人', trigger: 'blur' }
                    ],
                    fundManager: [
                        { required: true, message: '请输入基金托管人', trigger: 'blur' }
                    ],
                    fundMember: [
                        { required: true, message: '请输入基金经理', trigger: 'blur' }
                    ],
                    primaryType: [
                        { required: true, message: '请选择投资策略', trigger: 'change' }
                    ],
                    
                },
                tacticsList: [
                    {
                        id: '1000011',
                        label: '股票策略',
                    },
                    {
                        id: '1000012',
                        label: '相对价值',
                    },
                    {
                        id: '1000013',
                        label: '管理期货',
                    },
                    {
                        id: '1000014',
                        label: '宏观策略',
                    },
                    {
                        id: '1000015',
                        label: '事件驱动',
                    },
                    {
                        id: '1000016',
                        label: '债券基金',
                    },
                    {
                        id: '1000017',
                        label: '组合基金',
                    },
                    {
                        id: '1000018',
                        label: '其他策略',
                    },
                    {
                        id: '1000019',
                        label: '多策略',
                    },
                    {
                        id: '1000020',
                        label: '未分类',
                    }, 
                ],
                operateType: '',//修改类型
                operateInnerCode: '',//内部产品编号
            }
        },
        mounted() {
            this.getUserFundCenterResult()
            this.getUserFirmCenterResult()
            this.getInnerFundList()
        },
        updated() {
            this.$refs.custodianTableRef.doLayout()
        },
        methods: {
            // 基金自选
            getUserFundCenterResult() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetUserFundCenterResult, {
                    UserCode: vm.$commonJs.getCookie('userCode'), //用户编号
                    SortFlag: vm.fund.orderBy,//排序字段：-1最新净值日期，0最新净值，1年化收益，2近一月，3近三月，4近六月，5近一年，6近三年，7近五年，8今年以来，9成立以来，10-2021,11-2020,12-2019,13-2018,14-2017,15-2016，16-2015
                    SortArrow: vm.fund.orderFlag,//排序顺序：1升序，0降序
                    Page: vm.fund.page, //页码
                    PageNum: vm.fund.pageNum //每页条数
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == "200") {
                        vm.fundTable = res.data.data.dataList
                        vm.fund.pageAll = res.data.data.recordCount
                    }
                }).catch(err => { })
            },
            tableSortChange(val) {
                this.fund.orderFlag = val.order == 'ascending' ? 1 : 0
                // -1净值日期，0最新净值，1年化收益，2近一月，3近三月，4近六月，5近一年，6近三年，7近五年，8今年以来，9成立以来，10-2021,11-2020,12-2019,13-2018,14-2017,15-2016，16-2015
                switch (val.prop) {
                    case "newestDate":
                    this.fund.orderBy = -1;
                    break;
                    case "newestEquity":
                    this.fund.orderBy = 0;
                    break;
                    case "annualYield":
                    this.fund.orderBy = 1;
                    break;
                    case "oneMonthYield":
                    this.fund.orderBy = 2;
                    break;
                    case "threeMonthYield":
                    this.fund.orderBy = 3;
                    break;
                    case "sixMonthYield":
                    this.fund.orderBy = 4;
                    break;
                    case "oneYearYield":
                    this.fund.orderBy = 5;
                    break;
                    case "threeYearYield":
                    this.fund.orderBy = 6;
                    break;
                    case "fiveYearYield":
                    this.fund.orderBy = 7;
                    break;
                    case "thisYearYield":
                    this.fund.orderBy = 8;
                    break;
                    case "totalYield":
                    this.fund.orderBy = 9;
                    break;
                    case "lastYearYield":
                    this.fund.orderBy = 10;
                    break;
                    case "lastTwoYearYield":
                    this.fund.orderBy = 11;
                    break;
                    case "lastThreeYearYield":
                    this.fund.orderBy = 12;
                    break;
                    case "lastFourYearYield":
                    this.fund.orderBy = 13;
                    break;
                    case "lastFiveYearYield":
                    this.fund.orderBy = 14;
                    break;
                    case "lastSixYearYield":
                    this.fund.orderBy = 15;
                    break;
                    case "lastSevenYearYield":
                    this.fund.orderBy = 16;
                    break;
                }
                this.getUserFundCenterResult()
            },
            fundCurrentChange(newPage) {
                this.fund.page = newPage
                this.getUserFundCenterResult()
            },
            // 管理人自选
            getUserFirmCenterResult() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetUserFirmCenterResult, {
                    UserCode: vm.$commonJs.getCookie('userCode'), //用户编号
                    Page: vm.custodian.page, //页码
                    PageNum: vm.custodian.pageNum //每页条数
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == "200") {
                        vm.custodianTable = res.data.data.dataList
                        vm.custodian.pageAll = res.data.data.recordCount
                    }
                }).catch(err => { })
            },
            custodianCurrentChange(newPage) {
                this.custodian.page = newPage
                this.getUserFirmCenterResult()
            },
            // 去对比
            gotoContrast() {
                if(this.innerCodes.length == 0) {
                    this.$message.warning('请先选择要对比的基金')
                } else if(this.innerCodes.length > 5){
                    this.$message.warning('最多可选5只基金')
                } else {
                    this.$router.push({
                        name: 'fundComparison',
                        params: {
                            innerCodes: this.innerCodes
                        }
                    })
                }
            },
            handleSelectionChange(arr) {
                this.innerCodes = []
                arr.forEach((item,i) => {
                    this.innerCodes.push(item)
                })
            },
            // 内部产品
            getInnerFundList() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetInnerFundList, {
                    Page: vm.product.page, //页码
                    PageNum: vm.product.pageNum //每页条数
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == "200") {
                        vm.productTable = res.data.data.dataList
                        vm.product.pageAll = res.data.data.recordCount
                    }
                }).catch(err => { })
            },
            importChange(event, file, fileList, row) {
                this.$commonJs.getBase64(file.raw).then(result => {
                    this.importInner(result,file.name,row)
                });
                return false
            },
            importInner(result,name,row) {
                let vm = this
                vm.$http.post(vm.$apiPath.ImportInnerFundNetValue,{
                    InnerCode: row.innerCode,
                    FileName: name,    //文件名称
                    FileFlow: result,  //文件Base64字符串
                    FileType: 1,       //文件类型，列表接口里获取的值
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200 && res.data.data.note) {
                        vm.$message.success('估值表导入成功')
                    } else {
                        vm.$message.error('估值表导入失败')
                    }
                }).catch(err => {})
            },
            innerClose() {
                this.$refs.addFormRef.resetFields()
                this.dialogVisible = false
            },
            delInner(scope) {
                let vm = this
                vm.$confirm('要删除“'+scope.secuName+'” 吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    vm.$http.post(vm.$apiPath.DeleteInnerFund,{
                        InnerCode: scope.innerCode,
                    }).then(res => {
                        // console.log(res);
                        if(res.data.code == 200 && res.data.data.note) {
                            vm.$message.success('删除成功!')
                        } else {
                            vm.$message.error('删除失败!')
                        }
                        vm.getInnerFundList()
                    }).catch(err=>{})
                    
                }).catch(err=>{})
            },
            operateInner(type,val) {
                let vm = this
                vm.operateType = type
                if(type == 'edit') {
                    vm.operateInnerCode = val.innerCode
                    let tactics = vm.tacticsList.find(item => item.label == val.primaryType)
                    vm.addForm = {
                        name: val.secuName,
                        regNum: val.regNum,
                        createDate: val.createDate,
                        fundAdviser: val.fundAdviser,
                        fundManager: val.fundManager,
                        fundMember: val.fundMember,
                        primaryType: tactics.id,
                    }
                } else if(type == 'add'){
                    vm.addForm = {
                        name: '',
                        regNum: '',
                        createDate: '',
                        fundAdviser: '',
                        fundManager: '',
                        fundMember: '',
                        primaryType: '',
                    }
                }
                vm.dialogVisible = true
            },
            saveInner() {
                let vm = this
                vm.$refs.addFormRef.validate(valid => {
                    if(!valid) return false;
                    if(vm.operateType == 'add') {//添加
                        vm.$http.post(vm.$apiPath.AddedInnerFund, {
                            SecuName: vm.addForm.name,          //产品名称
                            RegNum: vm.addForm.regNum,          //备案编号
                            CreateDate: vm.addForm.createDate,  //成立日期
                            FundAdviser: vm.addForm.fundAdviser,//基金管理人
                            FundManager: vm.addForm.fundManager,//基金托管人
                            FundMember: vm.addForm.fundMember,  //基金经理
                            PrimaryType: vm.addForm.primaryType,//投资策略
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == "200" && res.data.data.note) {
                                vm.$message.success('创建成功')
                            } else {
                                vm.$message.error('创建失败')
                            }
                            vm.innerClose()
                            vm.getInnerFundList()
                        }).catch(err => { })
                    } else if(vm.operateType == 'edit') {//编辑
                        vm.$http.post(vm.$apiPath.UpdateInnerFund, {
                            InnerCode: vm.operateInnerCode,     //产品编号
                            SecuName: vm.addForm.name,          //产品名称
                            RegNum: vm.addForm.regNum,          //备案编号
                            CreateDate: vm.addForm.createDate,  //成立日期
                            FundAdviser: vm.addForm.fundAdviser,//基金管理人
                            FundManager: vm.addForm.fundManager,//基金托管人
                            FundMember: vm.addForm.fundMember,  //基金经理
                            PrimaryType: vm.addForm.primaryType,//投资策略
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == "200" && res.data.data.note) {
                                vm.$message.success('编辑成功')
                            } else {
                                vm.$message.error('编辑失败')
                            }
                            vm.innerClose()
                            vm.getInnerFundList()
                        }).catch(err => { })
                    }
                })
            },
        }
    }
</script>

<style scoped lang="less">
.personalCenter {
    .el-table .cell, .el-table--border /deep/.el-table__cell:first-child .cell {padding-right: 10px;}
    .text-r {text-align: right;}
    .dialog-normal /deep/.el-dialog {
        width: 800px;
        .clearfix {padding: 0 86px;}
    }
    .date-picker-one.el-date-editor /deep/.el-input__inner {text-align: left;padding: 0 10px;}
}
</style>